import apollo from '@/apollo.js'
import gql from 'graphql-tag'
import { TIMELINE_EVENT_FIELDS, normalizeTimelineDays } from '@/provider/timelineFields.js'

export const findCaseTimeline = async (caseId, criteria) => {
  const response = await apollo.query(
    {
      query: gql(`
        query CaseTimeline($caseId: String!, $criteria: TimelineCriteria!) {
          caseTimeline(
            caseId: $caseId
            criteria: $criteria
          ) {
            date
            events {
              ${TIMELINE_EVENT_FIELDS}
            }
          }
        }
      `),
      variables: { caseId, criteria }
    })
  return normalizeTimelineDays(response.data.caseTimeline)
}

export const getAuditLog = async (criteria) => {
  const response = await apollo.query(
    {
      query: gql(`
        query AuditLog($criteria: TimelineCriteria!) {
          auditLog(criteria: $criteria) {
            date
            events {
              ${TIMELINE_EVENT_FIELDS}
            }
          }
        }
      `),
      variables: { criteria },
      fetchPolicy: "network-only"
    })
  return normalizeTimelineDays(response.data.auditLog)
}

export const getUserTimeline = async (userId, criteria) => {
  const response = await apollo.query(
    {
      query: gql(`
        query UserTimeline($userId: Int!, $criteria: TimelineCriteria!) {
          userTimeline(
            userId: $userId
            criteria: $criteria
          ) {
            date
            events {
              ${TIMELINE_EVENT_FIELDS}
            }
          }
        }
      `),
      variables: { userId, criteria }
    })
  return normalizeTimelineDays(response.data.userTimeline)
}
